import {
  Avatar,
  Box,
  Flex,
  Stack,
  HStack,
  Text,
  Image,
  Heading,
} from "@chakra-ui/react";
import React from "react";
import { BsFillCheckCircleFill, BsFillStarFill } from "react-icons/bs";
import { AiOutlineRight } from "react-icons/ai";
import { Link } from "react-router-dom";

export default function GigDetails() {
  return (
    <Box mt={4} borderRadius={6} overflow="hidden">
      <Flex>
        <Stack
          w={{ base: "45%", "2xl": "30%" }}
          bg="#eeeeee"
          justifyContent="center"
          alignItems="center"
          p={4}
          borderRight={{base:"1px","2xl":"0px"}}
          borderColor="#c5c5c5"
          cursor="pointer"
          
        >
        <Link to="/seller">
          <Avatar
            src="/images/freelancer/profiles/6.png"
            size="lg"
            alignItems="start"
          >
            <Box
                as="span"
                pos="relative"
                left="-12px"
                top="6px"
                p="6px"
                fontSize="xs"
                fontWeight="bold"
                lineHeight="none"
                color="green.100"
                // transform="translate(50%,-50%)"
                bg="#00D900"
                rounded="full"
              />
          </Avatar>
          </Link>
          <Link to="/seller">
          <HStack color="#0079BC" >
            <Text fontWeight="bold">Logo Master</Text>
            <BsFillCheckCircleFill color="#52B9F3" />
          </HStack>
          </Link>
          <HStack>
            <Box color="#FFBE5B">
              <BsFillStarFill />
            </Box>
            <Text fontWeight="bold">4.8</Text>
            <Text color="#888" fontWeight="bold">
              (2k)
            </Text>
          </HStack>
        </Stack>
        <Stack
          bg="#f7f7f7"
          w={{ base: "55%", "2xl": "full" }}
          justifyContent={{ base: "center", "2xl": "start" }}
          px={{ base: 2, "2xl": 0 }}
        >
          <HStack
            px={{ base: 2, "2xl": 6 }}
            justifyContent="space-between"
            w="full"
            alignItems="start"
            borderBottom={{ "2xl": "1px" }}
            borderColor="#c5c5c5"
            pb={2}
          >
            <HStack>
              <Image src="/images/gigImage/pro.png" w="58px" />
              <Text color="#676767" display={{ base: "none", "2xl": "block" }} fontSize="12px">
                1 Order in Queue
              </Text>
            </HStack>
            <Flex
              justifyContent="center"
              alignItems="center"
              color="brand.500"
              height="full"
              gap={2}
            >
              <HStack gap={1} display={{ base: "none", "2xl": "flex" }} fontSize={{base:"8px",md:"12px"}} alignItems="center" fontWeight="medium">
                <Text>Graphic Design</Text>
                <AiOutlineRight  />
                <Text>Logo Design</Text>
              </HStack>
              <Image src="/images/gigImage/verified-90px.png" w="90px" />
            </Flex>
          </HStack>

          <Heading
            fontWeight={"semibold"}
            color="#747474"
            px={{ base: 2, "2xl": 6 }}
            py={4}
            fontSize={"28px"}
            display={{ base: "none", "2xl": "block" }}
          >
            I will design 3 modern minimalist logo design
          </Heading>
          <Text
            color="gray.500"
            fontWeight={"medium"}
            fontSize="12px"
            display={{ base: "block", "2xl": "none" }}
          >
            1 Order in Queue
          </Text>
          <Flex
            gap={1}
            display={{ base: "flex", "2xl": "none" }}
            fontSize={10}
            alignItems="center"
            color="brand.500"
          >
            <Text wordBreak={"break-all"}>Graphic Design</Text>
            <AiOutlineRight />
            <Text wordBreak={"break-all"}>Logo Design</Text>
          </Flex>
        </Stack>
      </Flex>
      <Flex bg="#eee" borderTop={"1px"} borderColor="#c5c5c5">
        <Heading
          fontWeight={"semibold"}
          p={5}
          fontSize="16px"
          color="#000000AB"
          display={{ base: "block", "2xl": "none" }}
        >
          I will design 3 modern minimalist logo design
        </Heading>
      </Flex>
    </Box>
  );
}
